// using my own objectfit classes, because in lay options you can turn on objectfit compatibility mode
const hasObjectFit = document.documentElement && 'objectFit' in document.documentElement.style
if (hasObjectFit && layData.misc_options_alt_w100_h100_sizing == '') {
	// html add class
	document.documentElement.classList.add('lay-objectfit')
} else {
	// html add class
	document.documentElement.classList.add('lay-no-objectfit')
}

import vimeoplayer_custom_controls from './frontend/vimeo/vimeoplayer_custom_controls'
import { bindFullscreenChange } from './frontend/vimeo/vimeo_fullscreen_fix'
import vimeo_autoplay from './frontend/vimeo/vimeo_autoplay'
import html5video_custom_controls from './frontend/html5video/html5video_custom_controls'
import './frontend/lazyloadjs/lazyloadjs.js'
import './frontend/textanimations/textanimations.js'
import './frontend/textanimations/pageoverlays/textanimations_pageoverlays.js'
import cover_controller from './frontend/cover/cover_controller'
import { utility_controller, Utility } from './frontend/utility/utility_controller'
import { breakpoints_controller } from './frontend/breakpoints/breakpoints_controller'
import layout_controller from './frontend/layout/layout_controller'
import parallax_controller from './frontend/parallax/parallax_controller'
import html5video_controller from './frontend/html5video/html5video_controller'
import prevnext_controller from './frontend/prevnext/prevnext_controller'
import prevnext_news_controller from './frontend/prevnext/prevnext_news_controller'
import prevnext_deck_controller from './frontend/prevnext/prevnext_deck_controller'
import current_year_controller from './frontend/dynamic_text_placeholders/current_year_controller'
import time_controller from './frontend/dynamic_text_placeholders/time_controller'
import mouse_position_controller from './frontend/dynamic_text_placeholders/mouse_position_controller'
import scrolltotop_controller from './frontend/scrolltotop/scrolltotop_controller'
import showhide_onscroll_controller from './frontend/showhide_onscroll/showhide_onscroll_controller'
import maxwidth_controller from './frontend/maxwidth/maxwidth_controller'
import mobile_menu_controller from './frontend/mobile/mobile_menu_controller'
import mobile_projectthumbnails_controller from './frontend/mobile/mobile_projectthumbnails_controller'
import history_controller from './frontend/history/history_controller_new'
import intro_controller_new from './frontend/intro/intro_controller_new'
import search_controller from './frontend/search/search_controller'
import './frontend/html5video/play_pause_autoplay_videos_on_scroll'
import element_animate_in_on_scroll_controller from './frontend/element_animate_in_on_scroll/element_animate_in_on_scroll'
import scroll_animations_controller from './frontend/scroll_animations/scroll_animations'
import build_animation_groups_controller from './frontend/scroll_animations/build_animation_groups'
import sync_nav_anim_to_elements_controller from './frontend/animations/sync_nav_anim_to_elements'
import drag_physics_nav_fade_controller from './frontend/animations/drag_physics_nav_fade'
import marquee_scroll_drive_controller from './frontend/scroll_animations/marquee_scroll_drive'
import text_animation_scrub_controller from './frontend/textanimations/scrub'
import text_animation_scrub_for_pageoverlays_controller from './frontend/textanimations/pageoverlays/scrub_for_pageoverlays'
                                    
                                                               
          
// Dev Mode overlay (D-key toggle) — stripped from prod builds via ifdef.
// `dev_mode_emit` installs `window.layDevModeEmit` so non-module frontend
// code can fire dev-mode tracking events; every caller guards with
// `typeof window.layDevModeEmit === 'function'`, so prod (where the global
// is absent) no-ops safely.
                    
import './frontend/dev_mode/dev_mode_emit'
import './frontend/dev_mode/dev_mode_controller'
          
import pixelate_animated_effect_controller from './frontend/pixelate_animated_effect/pixelate_animated_effect'
import anchor_behaviour_controller from './frontend/anchorbehaviour/anchorbehaviour'
import './frontend/utility/_100vh_controller'
import thumbnailgrid_controller from './frontend/element/thumbnailgrid_controller'
import elementgrid_controller from './frontend/element/elementgrid_controller'
import projectindex_controller from './frontend/element/projectindex_controller'
import productindex_controller from './frontend/element/productindex_controller'
import socialmediaicons_controller from './frontend/element/socialmediaicons_controller'
import './frontend/element/newselement_controller'
import productsgrid_controller_new from './frontend/element/productsgrid_controller_new'
import { transition_timer_controller } from './frontend/history/transition_timer'
import qtranslate_controller from './frontend/qtranslate/qtranslate_controller'
import polylang_controller from './frontend/polylang/polylang_controller'
import load_cpl_or_desktop_content_controller from './frontend/load_cpl_or_desktop_content/load_cpl_or_desktop_content_controller'
import video_background from './frontend/html5video/video_background'
import submenu_controller from './frontend/submenu/submenu'
import thumbnailgrid_tagfilter_sizing_controller from './frontend/element/thumbnailgrid_tagfilter_sizing_controller'
import productsgrid_tagfilter_sizing_controller from './frontend/element/productsgrid_tagfilter_sizing_controller'
import positioning from './frontend/positioning/positioning'
import nag_controller from './frontend/nag/nag_controller'
import expandrow_controller from './frontend/expandrow/expandrow_controller'
import animations_controller from './frontend/animations/animations_controller'
import pageoverlays_animations_controller from './frontend/animations/page-overlays/pageoverlay_animations_controller'
import disable_transitions_for_deck from './frontend/animations/shared/disable_transitions_for_deck'
import { load_visible_images_then_rest_controller } from './frontend/utility/load_visible_images_then_rest.js'
import { initOverlayModule } from './frontend/page_overlay/page_overlay'
import page_overlay_loader from './frontend/page_overlay/page_overlay_loader'
import page_overlay_lifecycle_controller from './frontend/page_overlay/lifecycle/page_overlay_lifecycle_controller'
import './frontend/showhide_onscroll/showhide_for_phone'
import projects_overlays from './frontend/projects_overlays/projects_overlays'
import project_overlay_lifecycle_controller from './frontend/projects_overlays/lifecycle/project_overlay_lifecycle_controller'
import direct_load_controller from './frontend/projects_overlays/direct_load'
import element_animate_in_on_scroll_controller_for_pageoverlays from './frontend/element_animate_in_on_scroll/element_animate_in_on_scroll_for_pageoverlays'
import smooth_scroll_controller from './frontend/smooth_scroll/smooth_scroll_controller'
import horizontal_scroll_controller from './frontend/horizontal_scroll/horizontal_scroll_controller'
import './frontend/element/thumbnails_mouseover'
import './frontend/menupill/menupill.js'
import './frontend/menupill/menupill_phone.js'
import './frontend/element/accordion.js'
import './frontend/cache/image_url_normalizer'
import dom_cursor_controller from './frontend/dom_cursor/dom_cursor_controller'
import deck_controller from './frontend/deck/deck_controller'
import button_mouseover_effects_controller from './frontend/buttons/button_mouseover_effects'

// Resolve Build Animation groups BEFORE the first content_ready can fire —
// load_cpl_or_desktop_content_controller.i() may synchronously emit
// content_ready, and textanimations.js registered its handler at import time.
// If the group attrs are not resolved yet, above-the-fold text members can
// start outside the group lifecycle.
build_animation_groups_controller.i()
load_cpl_or_desktop_content_controller.i()
qtranslate_controller.i()
polylang_controller.i()
if (layData.is_customize != true) {
	intro_controller_new.init()
} else {
	intro_controller_new.cancelLoading()
}
prevnext_controller.i()
prevnext_news_controller.i()
prevnext_deck_controller.i()
current_year_controller.i()
time_controller.i()
mouse_position_controller.i()
history_controller.i()
utility_controller.i()
breakpoints_controller.i()
layout_controller.i()
parallax_controller.i()
html5video_controller.i()
scrolltotop_controller.i()
deck_controller.i()
button_mouseover_effects_controller.i()
disable_transitions_for_deck.i()
showhide_onscroll_controller.i()
maxwidth_controller.i()
mobile_menu_controller.i()
mobile_projectthumbnails_controller.i()
dom_cursor_controller.i()
cover_controller.i()
search_controller.i()
element_animate_in_on_scroll_controller.i()
// Build Animation groups are resolved near the top of this file, before
// load_cpl_or_desktop_content_controller can emit content_ready. Keep this
// note here because scroll_animations_controller still depends on that order:
// it writes `data-lay-scroll-anim-duration-frames` / `-delay-frames`
// onto each grouped member, and `scroll_animations_controller.i()` then
// parses those attrs into its element configs. Same goes for text
// animations: this controller writes `data-duration` / `data-delay`
// that the text-animation init reads. Running this first keeps the
// downstream code group-agnostic.
// Sync-with-Nav-Anim: for elements flagged with `data-lay-sync-nav-anim`
// + in viewport at page load + Lay Options nav-anim is stagger-up/down,
// borrow the nav-anim cascade slot's delay onto the element's own
// scroll- / text-animation data-attrs AND mark the host col with
// `no-animation` so nav-anim won't double up on the visual. Must run
// AFTER build_animation_groups (group may have already written its own
// duration/delay — we'd want sync to override only for elements
// explicitly flagged, which group members aren't) and BEFORE
// scroll_animations_controller / text-anim init.
sync_nav_anim_to_elements_controller.i()
// Drag-physics elements have `no-animation`, so they're excluded from the
// nav-animation column cascade. Give them a plain opacity fade synced to
// the page transition (skipped when the nav-anim mode is `none`).
drag_physics_nav_fade_controller.i()
scroll_animations_controller.i()
marquee_scroll_drive_controller.i()
text_animation_scrub_controller.i()
text_animation_scrub_for_pageoverlays_controller.i()
                                    
                                                    
                           
 
                    
                          
          
          
pixelate_animated_effect_controller.i()
element_animate_in_on_scroll_controller_for_pageoverlays.i()
anchor_behaviour_controller.i()
thumbnailgrid_controller.i()
elementgrid_controller.i()
projectindex_controller.i()
productindex_controller.i()
socialmediaicons_controller.i()
productsgrid_controller_new.i()
transition_timer_controller.i()
video_background.i()
submenu_controller.i()
thumbnailgrid_tagfilter_sizing_controller.i()
productsgrid_tagfilter_sizing_controller.i()
positioning.i()
nag_controller.i()
expandrow_controller.i()
bindFullscreenChange()
animations_controller.i()
pageoverlays_animations_controller.i()
page_overlay_lifecycle_controller.i()
project_overlay_lifecycle_controller.i()
projects_overlays.i()
vimeoplayer_custom_controls.i()
html5video_custom_controls.i()
vimeo_autoplay.i()
initOverlayModule()
page_overlay_loader.i()
smooth_scroll_controller.i()
horizontal_scroll_controller.i()

// initial trigger of newpageshown!
// initial newpageshown

var type = document.body.dataset.type
var id = document.body.dataset.id
var slug = document.body.dataset.slug
var catid = document.body.dataset.catid
var footerid = document.body.dataset.footerid
var htmlElement = document.documentElement
var horizontalScrollActiveAttr = (document.body && document.body.dataset.horizontalScrollActive) || (htmlElement && htmlElement.dataset.horizontalScrollActive) || '0'
var horizontalScrollActive = (htmlElement && htmlElement.classList.contains('horizontal-scroll-active')) || horizontalScrollActiveAttr === '1'
var title = document.title.replace(passedDataHistory.titleprefix, '')
var hasCustomPhoneLayout = false
var initialLayContent = document.querySelector('body>.lay-content')
if (initialLayContent && initialLayContent.classList.contains('hascustomphonegrid')) {
	hasCustomPhoneLayout = true
}

// Direct-load: bootstraps overlay state when PHP rendered a project URL
// directly inside the overlay container. Returns false (no-op) on regular
// page loads. The initial newpageshown below uses isActive() to flip its
// scope flag so scoped listeners init for the right .lay-content root.
direct_load_controller.bootstrapIfNeeded()

// if i dont wrap this in a document ready, the carousel addon's window.laytheme.on('newpageshown') wont trigger
document.addEventListener('DOMContentLoaded', function () {
	// If I dont do a settimeout, html5 videos will sometimes not be bound to click events
	setTimeout(function () {
		window.laytheme.emit('newpage')
		var obj = {
			id: id,
			type: type,
			slug: slug,
			catid: catid,
			footerid: footerid,
			title: title,
			horizontal_scroll_active: horizontalScrollActive,
			has_custom_phone_layout: hasCustomPhoneLayout,
		}
		window.laytheme.emit('newpageshown', {}, type, obj, { isProjectOverlay: direct_load_controller.isActive() })
		// Lazy-fetch the underlay (no-op when not in direct-load mode or
		// when the underlay can't be lazy-loaded due to shortcodes).
		direct_load_controller.fetchUnderlay()
	}, 0)
})

window.load_visible_images_then_rest_controller = load_visible_images_then_rest_controller
window.element_animate_in_on_scroll_controller = element_animate_in_on_scroll_controller
window.lt_utility_controller = {}
window.lt_utility_controller.Utility = Utility
window.lt_utility_controller.utility_controller = utility_controller
window.lt_showhide_onscroll_controller = {}
window.lt_showhide_onscroll_controller.default = showhide_onscroll_controller

// for carousel and overlay:
if (layData.youtube == 'on') {
	// init youtube api
	// https://developers.google.com/youtube/iframe_api_reference
	var tag = document.createElement('script')
	tag.src = 'https://www.youtube.com/iframe_api'
	var firstScriptTag = document.getElementsByTagName('script')[0]
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

window.addEventListener('load', function () {
	// loaded
	layout_controller.loadMasterCache()
})
